export default __webpack_public_path__ + "static/media/README.5961364b.md";